import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Data Entry',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
